import React from 'react'

import JoinContent from './Join/Content'

const HomePage = (props) => <JoinContent homePage={props.homePage} isHomePage={true} />

export default HomePage
